// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemCard_container__chUL7"};